"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link ZonePrices}.</p>
 *
 * @author Jaroslav Sevcik
 */


var ZonePricesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ZonePricesConverter, _DataObjectConverter_);

  function ZonePricesConverter() {
    _classCallCheck(this, ZonePricesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZonePricesConverter).apply(this, arguments));
  }

  return ZonePricesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ZonePricesConverter = ZonePricesConverter;